import React from 'react';
import {
  Chart,
  Interval,
  Tooltip,
  Interaction,
  Axis,
  Coordinate,
  // getTheme,
  Legend,
} from 'bizcharts';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import styles from '../pages/dashboard/styles.module.scss';
import { tooltipClasses } from '@mui/material/Tooltip';
import { Tooltip as Expansive } from '@mui/material';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { diasSemana, numberLocale } from './mask';

const ChartTooltip = styled(({ className, ...props }) => (
  <Expansive {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff',
    color: 'rgba(0, 0, 0, 0.7)',
    maxWidth: 230,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #ccc',
  },
}));

// Gráfico barra
export const NewGraphBar = ({
  dataGraphs,
  total,
  label,
  labelOtherColor,
  subLabel,
  subLabelOtherColor,
  labelModal,
  position,
  axisY,
  date,
  tipoAtendimento,
  otherTitle,
  subLabelModal,
}) => {
  const labelInfo = () => {
    let info = '';

    if (label === 'APA') {
      info = (
        <>
          <h3 className={styles.graph_bar_title_ap}>{label}</h3>
          <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>
            Acessos ao App Sebrae
          </p>
        </>
      );
    } else if (label === 'APB') {
      info = (
        <>
          <h3 className={styles.graph_bar_title_ap}>{label}</h3>
          <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>
            Visualização de boleto DAS MEI
          </p>
        </>
      );
    } else if (label === 'APC') {
      info = (
        <>
          <h3 className={styles.graph_bar_title_ap}>{label}</h3>
          <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>
            Visualização de conteúdo
          </p>
        </>
      );
    } else if (label === 'APD') {
      info = (
        <>
          <h3 className={styles.graph_bar_title_ap}>{label}</h3>
          <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>
            Realização de diagnósticos
          </p>
        </>
      );
    } else if (label === 'APE') {
      info = (
        <>
          <h3 className={styles.graph_bar_title_ap}>{label}</h3>
          <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>
            Visualização de produtos e serviços
          </p>
        </>
      );
    } else if (label === 'APL') {
      info = (
        <>
          <h3 className={styles.graph_bar_title_ap}>{label}</h3>
          <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>
            Utilização do fluxo de caixa
          </p>
        </>
      );
    } else if (label === 'APM') {
      info = (
        <>
          <h3 className={styles.graph_bar_title_ap}>{label}</h3>
          <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>
            Recomendação de marketplaces
          </p>
        </>
      );
    } else if (label === 'APN') {
      info = (
        <>
          <h3 className={styles.graph_bar_title_ap}>{label}</h3>
          <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>
            Publicação de anúncios
          </p>
        </>
      );
    } else if (label === 'APR') {
      info = (
        <>
          <h3 className={styles.graph_bar_title_ap}>{label}</h3>
          <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>
            Realização de atendimento ativo
          </p>
        </>
      );
    } else if (label === 'APS') {
      info = (
        <>
          <h3 className={styles.graph_bar_title_ap}>{label}</h3>
          <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>
            Interação com o assistente digital
          </p>
        </>
      );
    } else if (label === 'Média PJ únicos por porte') {
      info = (
        <>
          <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>Atendimentos:</p>
          <h3 style={{ fontSize: 15, marginBottom: 12 }}>{label}</h3>
        </>
      );
    } else {
      info = (
        <>
          <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>
            {otherTitle ? otherTitle : 'Atendimentos '}
            {otherTitle ? null : tipoAtendimento ? tipoAtendimento : null}:
          </p>
          {labelOtherColor ? (
            label === 'ativos agora' ? (
              <div style={{ display: 'flex' }}>
                <h3 className={styles.graph_bar_title}>{label}</h3>
                <h3
                  className={styles.graph_bar_title}
                  style={{
                    color: labelOtherColor === 'PF' ? '#00CCFF4D' : '#00CCFFB2',
                  }}
                >
                  {labelOtherColor}
                </h3>
              </div>
            ) : (
              <div style={{ display: 'flex' }}>
                <h3
                  className={styles.graph_bar_title}
                  style={{
                    color: labelOtherColor === 'PF' ? '#00CCFF4D' : '#00CCFFB2',
                  }}
                >
                  {labelOtherColor}
                </h3>
                <h3 className={styles.graph_bar_title}>{label}</h3>
              </div>
            )
          ) : (
            <h3 className={styles.graph_bar_title}>{label}</h3>
          )}
        </>
      );
    }

    return info;
  };
  return (
    <div className={styles.graph_bar_content}>
      {labelInfo()}
      <Chart
        autoFit
        data={dataGraphs}
        // className={styles.data_graph_container}
        className={
          label === 'dias da semana'
            ? styles.data_graph_container_diasSemana
            : styles.data_graph_container
        }
      >
        <Interval
          position={position}
          color={
            subLabelOtherColor && subLabelOtherColor === 'PF'
              ? '#00CCFF4D'
              : label === 'APA' || label === 'APS'
              ? '#E2E5E7'
              : '#00CCFF'
          }
        />
        <Tooltip
          shared
          title={(value, item) =>
            `${
              labelModal === 'tempo médio de acesso'
                ? ''
                : otherTitle
                ? otherTitle + ':'
                : 'Atendimentos'
            } ${tipoAtendimento ? tipoAtendimento : ''}
            ${labelModal ? labelModal : label} 
            ${subLabelModal ? subLabelModal : ''}
            ${
              label === 'registros SAS' ||
              label === 'APA' ||
              label === 'APB' ||
              label === 'APC' ||
              label === 'APD' ||
              label === 'APE' ||
              label === 'APL' ||
              label === 'APM' ||
              label === 'APN' ||
              label === 'APR' ||
              label === 'APS' ||
              label === 'total hoje'
                ? '\n'
                : ''
            } ${
              label === 'distribuição por hora' ||
              label === 'distribuição no dia' ||
              label === 'total hoje'
                ? `${
                    date?.find(
                      (i) => i.total === item.total && i.hora === item.hora
                    ).horaModal
                  } h`
                : label === 'dias da semana'
                ? diasSemana(
                    date?.find(
                      (i) => i.total === item.total && i.dia === item.dia
                    ).diaModal
                  )
                : date?.find(
                    (i) => i.mes === item.mes && i.total === item.total
                  ).dataFinal
            }`
          }
        />

        {/* <Tooltip shared /> */}
        <Axis name={axisY ? 'média' : 'total'} visible={false} />
        {/* <Axis name="mes" visible={false} /> */}
      </Chart>
      <p className={styles.graph_bar_total_label}>
        {numberLocale(total)}
        {''}
        {subLabel === 'segundos de engajamento' ? 's' : ''}
      </p>
      {subLabelOtherColor ? (
        <div style={{ display: 'flex' }}>
          <p className={styles.graph_bar_registros_sublabel}>{subLabel}</p>
          <p
            className={
              subLabelOtherColor === 'PF'
                ? styles.graph_bar_registros_sublabel_OtherPfmap
                : styles.graph_bar_registros_sublabel_OtherPj
            }
          >
            {subLabelOtherColor}
          </p>
        </div>
      ) : (
        <p className={styles.graph_bar_registros_sublabel}>{subLabel}</p>
      )}
    </div>
  );
};

// GRÁFICO MÉDIA POR PORTE
export const NewGraphBarPorte = ({
  dataGraphs,
  title,
  total,
  label,
  subLabel,
  labelModal,
  position,
  axisY,
  slModal,
  tipoAtendimento,
}) => {
  return (
    <div className={styles.graph_bar_content}>
      <>
        <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>
          {title ? title : 'Atendimentos'}{' '}
          {tipoAtendimento ? tipoAtendimento : ''}:
        </p>
        <h3 className={styles.graph_bar_title}>{label}</h3>
      </>
      <Chart autoFit data={dataGraphs} className={styles.data_graph_container}>
        <Interval position={position} color="#11CEFD" />
        <Tooltip
          shared
          title={(value, idx) =>
            `${
              title
                ? title + ': \n'
                : `Atendimentos ${tipoAtendimento ? '' : ':'}`
            } ${tipoAtendimento ? tipoAtendimento + ':' : ''} ${
              labelModal ? labelModal : label
            } ${
              // prettier-ignore
              slModal?.find(
              (i) => (i.sigla === idx.sigla) && (i.média === idx.média)
            ).siglaModal
            }`
          }
        />

        <Axis name={axisY ? 'média' : 'total'} visible={false} />
      </Chart>
      <p className={styles.graph_bar_total_label}>{numberLocale(total)}</p>
      <p className={styles.graph_bar_registros_sublabel}>{subLabel}</p>
    </div>
  );
};

export const GraphBarExpansivCard = ({
  dataGraphs,
  total,
  label,
  position,
  subLabel,
  ccPj,
  maquininhas,
  servContabil,
  oport,
  mLocal,
  date,
}) => {
  return (
    <div className={styles.graph_bar_content}>
      <div className={styles.graph_exp_title}>
        <div>
          {label === 'APF' ? (
            <>
              <h3 className={styles.graph_bar_title_ap}>{label}</h3>
              <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>
                Recomendação de serv. financeiros
              </p>
            </>
          ) : (
            <>
              <h3 className={styles.graph_bar_title_ap}>{label}</h3>
              <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>
                Recomendação de oportunidades
              </p>
            </>
          )}
        </div>
        <div className={styles.graph_chartTooltip}>
          <ChartTooltip
            title={
              <React.Fragment>
                <Typography color="inherit">Atendimentos por tipo</Typography>
                {label === 'APF' ? (
                  <div>
                    <p>
                      1. Conta corrente PJ: <strong>{ccPj}</strong>
                    </p>
                    <p>
                      2. Maquininhas: <strong>{maquininhas}</strong>{' '}
                    </p>
                    <p>
                      3. Serviços contábeis: <strong>{servContabil}</strong>{' '}
                    </p>
                  </div>
                ) : (
                  <div>
                    <p>
                      1. Oportunidades: <strong>{oport}</strong>
                    </p>
                    <p>
                      2. Melhor Local: <strong>{mLocal}</strong>{' '}
                    </p>
                  </div>
                )}
              </React.Fragment>
            }
          >
            <svg
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.42268 8.22878C6.09729 7.92358 5.56981 7.92358 5.24404 8.22878C4.91865 8.53398 4.91865 9.0291 5.24404 9.3343L9.41077 13.2425C9.73616 13.5477 10.264 13.5477 10.5894 13.2425L14.7561 9.3343C15.0815 9.0291 15.0815 8.53434 14.7561 8.22878C14.4308 7.92358 13.9029 7.92358 13.5775 8.22878L10.0001 11.5842L6.42268 8.22878Z"
                fill="#00CCFF"
              />
              <path
                d="M10 0C4.48566 0 0 4.49954 0 10.0309C0 15.5623 4.48566 20.0619 10 20.0619C15.5143 20.0619 20 15.5615 20 10.0309C20 4.50032 15.5143 0 10 0ZM10 18.5079C5.34082 18.5079 1.54918 14.7053 1.54918 10.0309C1.54918 5.35656 5.34082 1.55397 10 1.55397C14.6592 1.55397 18.4508 5.35656 18.4508 10.0309C18.4508 14.7053 14.66 18.5079 10 18.5079Z"
                fill="#00CCFF"
              />
            </svg>
          </ChartTooltip>
        </div>
      </div>
      <Chart
        // height={108}
        // width={155}
        autoFit
        data={dataGraphs}
        className={styles.data_graph_container}
      >
        <Interval position={position} color="#00ccff" />
        <Tooltip
          shared
          title={(value, idx, item) =>
            `Atendimentos: ${label} \n ${
              date?.find((i) => i.mes === idx.mes && i.total === idx.total)
                .dataFinal
            }`
          }
        />
        <Axis name="total" visible={false} />
      </Chart>
      <p className={styles.graph_bar_total_label}>{numberLocale(total)}</p>
      <p className={styles.graph_bar_registros_sublabel}>{subLabel}</p>
    </div>
  );
};

// Gráfico barra customizado
export const NewGraphBarCustom = ({
  dataGraphs,
  total1,
  total2,
  total3,
  label,
  position,
}) => {
  return (
    <div className={styles.graph_bar_content}>
      <div className={styles.graph_exp_title}>
        <div>
          <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>Atendimentos:</p>
          <h4 className={styles.graph_bar_title}>{label}</h4>
        </div>
        <div className={styles.graph_chartTooltip}>
          <ChartTooltip
            title={
              <React.Fragment>
                <Typography color="inherit">Legenda</Typography>
                <p>
                  {' '}
                  <strong>OTD: </strong> Orientação Técnica à Distância{' '}
                </p>
                <p>
                  {' '}
                  <strong>IAD: </strong> Informação à Distância{' '}
                </p>
                <p>
                  {' '}
                  <strong>CON: </strong> Consultoria{' '}
                </p>
              </React.Fragment>
            }
          >
            <svg
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.42268 8.22878C6.09729 7.92358 5.56981 7.92358 5.24404 8.22878C4.91865 8.53398 4.91865 9.0291 5.24404 9.3343L9.41077 13.2425C9.73616 13.5477 10.264 13.5477 10.5894 13.2425L14.7561 9.3343C15.0815 9.0291 15.0815 8.53434 14.7561 8.22878C14.4308 7.92358 13.9029 7.92358 13.5775 8.22878L10.0001 11.5842L6.42268 8.22878Z"
                fill="#00CCFF"
              />
              <path
                d="M10 0C4.48566 0 0 4.49954 0 10.0309C0 15.5623 4.48566 20.0619 10 20.0619C15.5143 20.0619 20 15.5615 20 10.0309C20 4.50032 15.5143 0 10 0ZM10 18.5079C5.34082 18.5079 1.54918 14.7053 1.54918 10.0309C1.54918 5.35656 5.34082 1.55397 10 1.55397C14.6592 1.55397 18.4508 5.35656 18.4508 10.0309C18.4508 14.7053 14.66 18.5079 10 18.5079Z"
                fill="#00CCFF"
              />
            </svg>
          </ChartTooltip>
        </div>
      </div>
      <Chart
        // height={126}
        // width={155}
        autoFit
        data={dataGraphs}
        className={styles.data_graph_container}
      >
        {/* <Coordinate transpose /> */}
        <Interval position={position} color="#00ccff" />
        <Tooltip shared />
        <Axis name="totalAtendimentos" visible={false} />
      </Chart>
      <div
        // style={{
        //   display: 'flex',
        //   flexDirection: 'row',
        //   justifyContent: 'space-between',
        //   paddingRight: 15,
        //   paddingLeft: 15,
        // }}
        className={styles.graph_bar_tipoInst}
      >
        <p className={styles.graph_bar_total_tipoInst}>
          {numberLocale(total1)}
        </p>
        <p className={styles.graph_bar_total_tipoInst}>
          {numberLocale(total2)}
        </p>
        <p className={styles.graph_bar_total_tipoInst}>
          {numberLocale(total3)}
        </p>
      </div>
    </div>
  );
};

// Gráfico barra lateral customizado com UMA aba
export const GraphBarCustomLateralONE = ({
  dataGraphsUf,
  // dataGraphsUserUf,
  position,
  tab1,
  label,
  titleUF,
}) => {
  return (
    <div className={styles.graph_bar_lateral_content}>
      <p style={{ fontSize: 12, marginLeft: '0.5rem', marginTop: '0.3rem' }}>
        {label}
      </p>
      <div
        style={{
          width: '100%',
          fontSize: '14px',
          paddingBottom: '0.5rem',
          fontWeight: 'bold',
          marginLeft: '0.5rem',
        }}
      >
        {tab1}
      </div>

      <div className="tabPanel-lateral">
        <Chart
          autoFit
          data={dataGraphsUf.sort((a, b) => a.total - b.total)}
          className={styles.chartBar_lateral}
        >
          <Coordinate transpose />
          <Interval position={position} color="#00ccff" />
          <Axis name="total" visible={false} />
          <Tooltip
            shared
            title={(value, idx) =>
              `Usuários: \n Distribuição por UF\n ${
                // prettier-ignore
                titleUF?.find(
            (i) => (i.uf === idx.uf) && (i.total === idx.total)
          ).sigleUF
              }`
            }
          />
        </Chart>
      </div>
    </div>
  );
};
// Gráfico barra lateral customizado com DUAS abas
export const GraphBarCustomLateral = ({
  dataGraphsAtendUf,
  dataGraphsUserUf,
  position,
  tab1,
  tab2,
  titleUF,
  titleUF2,
  otherTitle,
}) => {
  return (
    <Tabs className={styles.graph_bar_lateral_content}>
      {otherTitle ? (
        <p style={{ fontSize: 12, marginLeft: '0.2rem', marginTop: '0.3rem' }}>
          {otherTitle}:
        </p>
      ) : (
        ''
      )}
      <TabList>
        <Tab
          style={{
            width: 80,
            fontSize: '14px',
            padding: 5,
            fontWeight: 'bold',
          }}
        >
          {tab1}
        </Tab>
        <Tab
          style={{
            width: 80,
            fontSize: '14px',
            padding: 5,
            fontWeight: 'bold',
          }}
        >
          {tab2}
        </Tab>
        {/* <Tab className={styles.chartBar_lateral_tab_label}>{tab1}</Tab>
        <Tab className={styles.chartBar_lateral_tab_label}>{tab2}</Tab> */}
      </TabList>

      {/* <TabPanel style={{ width: 180, height: 415 }}> */}
      <TabPanel className="tabPanel-lateral">
        <Chart
          // height={525}
          // width={140}
          autoFit
          data={dataGraphsAtendUf?.sort((a, b) => a?.total - b?.total)}
          className={styles.chartBar_lateral}
        >
          <Coordinate transpose />
          <Interval position={position} color="#00ccff" />
          <Axis name="total" visible={false} />
          <Tooltip
            shared
            title={(value, idx) =>
              `${
                otherTitle ? otherTitle : 'Atendimentos'
              }: \n Distribuição por UF\n ${
                // prettier-ignore
                titleUF?.find(
                (i) => (i.uf === idx.uf) && (i.total === idx.total)
              ).sigleUF
              }`
            }
          />
        </Chart>
      </TabPanel>
      {/* <TabPanel style={{ width: 180, height: 415 }}> */}
      <TabPanel className="tabPanel-lateral">
        <Chart
          // height={525}
          // width={140}
          autoFit
          // pure
          data={dataGraphsUserUf?.sort((a, b) => a?.total - b?.total)}
          className={styles.chartBar_lateral}
        >
          <Coordinate transpose />
          <Interval position={position} color="#00ccff" />
          <Axis name="total" visible={false} />
          <Tooltip
            shared
            title={(value, idx) =>
              `${
                otherTitle ? otherTitle : 'Atendimentos'
              }: \n Distribuição por UF\n ${
                // prettier-ignore
                titleUF2?.find(
                  (i) => (i.uf === idx.uf) && (i.total === idx.total)
                  ).sigleUF
              }`
            }
          />
        </Chart>
      </TabPanel>
    </Tabs>
  );
};
// Gráfico barra lateral customizado com TRES abas
export const GraphBarCustomLateralTriplo = ({
  dataGraphsUf,
  dataGraphsCidade,
  dataGraphsAgente,
  position,
  tab1,
  tab2,
  tab3,
  titleUF,
  titleCidade,
  titleAtendente,
}) => {
  return (
    <Tabs className={styles.graph_bar_lateral_content}>
      <p
        style={{
          fontSize: 12,
          marginLeft: '0.5rem',
          marginBottom: '0.2rem',
          marginTop: '0.2rem',
        }}
      >
        Atendimentos SSE:
      </p>
      <TabList>
        <Tab
          style={{
            width: 61,
            fontSize: '14px',
            padding: 5,
            fontWeight: 'bold',
          }}
        >
          {tab1}
        </Tab>
        <Tab
          style={{
            width: 61,
            fontSize: '14px',
            padding: 5,
            fontWeight: 'bold',
          }}
        >
          {tab2}
        </Tab>
        <Tab
          style={{
            width: 61,
            fontSize: '14px',
            padding: 5,
            fontWeight: 'bold',
          }}
        >
          {tab3}
        </Tab>
        {/* <Tab className={styles.chartBar_lateral_tab_label}>{tab1}</Tab>
        <Tab className={styles.chartBar_lateral_tab_label}>{tab2}</Tab> */}
      </TabList>

      {/* <TabPanel style={{ width: 180, height: 415 }}> */}

      {/* 1 */}
      <TabPanel>
        <Chart
          // height={525}
          // width={140}
          autoFit
          data={dataGraphsUf.sort((a, b) => a.total - b.total)}
          className={styles.chartBar_lateral_triplo}
        >
          <Coordinate transpose />
          <Interval position={position} color="#00ccff" />
          <Axis name="total" visible={false} />
          <Tooltip
            shared
            title={(value, idx) =>
              `Atendimentos SSE: \n Distribuição por UF\n ${
                // prettier-ignore
                titleUF?.find(
                (i) => (i.uf === idx.uf) && (i.total === idx.total)
              ).sigleUF
              }`
            }
          />
        </Chart>
      </TabPanel>

      {/* <TabPanel style={{ width: 180, height: 415 }}> */}

      {/* 2 */}
      <TabPanel className="tabPanel-lateral">
        <Chart
          // height={525}
          // width={140}
          autoFit
          // pure
          data={dataGraphsCidade.sort((a, b) => a.total - b.total)}
          className={styles.chartBar_lateral_triplo_Cidade}
        >
          <Coordinate transpose />
          <Interval position={position} color="#00ccff" />
          <Axis name="total" visible={false} />
          <Tooltip
            shared
            title={(value, idx) =>
              `Atendimentos SSE: \n Distribuição por cidade\n ${
                // prettier-ignore
                titleCidade?.find(
                (i) => (i.uf === idx.uf) && (i.total === idx.total)
              ).nameCidade
              }`
            }
          />
        </Chart>
      </TabPanel>

      {/* 3 */}
      <TabPanel className="tabPanel-lateral">
        <Chart
          // height={525}
          // width={140}
          autoFit
          // pure
          data={dataGraphsAgente.sort((a, b) => a.total - b.total)}
          className={styles.chartBar_lateral_triplo_Agente}
        >
          <Coordinate transpose />
          <Interval position={position} color="#00ccff" />
          <Axis name="total" visible={false} />
          <Tooltip
            shared
            title={(value, idx) =>
              `Atendimentos SSE: \n Distribuição por cidade\n ${
                // prettier-ignore
                titleAtendente?.find(
                (i) => (i.uf === idx.uf) && (i.total === idx.total)
              ).nameAtendente
              }`
            }
          />
        </Chart>
      </TabPanel>
    </Tabs>
  );
};

// Gráfico Barra agrupado
export const GraphBarGrouped = ({
  title,
  label,
  dataGraphs,
  porcemPf,
  porcemPj,
  position,
  date,
  iten1,
  iten2,
  porcemSimbol,
  tipoAtendimento,
}) => {
  // const scale = {
  //   mes: {
  //     alias: 'mes',
  //   },
  //   total: {
  //     alias: 'porcentagem',
  //   },
  // };
  return (
    <div className={styles.graph_bar_content}>
      {title ? (
        <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>
          {title} {tipoAtendimento ? tipoAtendimento : ''}:
        </p>
      ) : (
        <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>
          Atendimentos {tipoAtendimento ? tipoAtendimento : ''}:
        </p>
      )}

      <h3 className={styles.graph_bar_title}>{label}</h3>
      <Chart
        // height={127}
        // width={150}
        className={styles.data_graph_container}
        padding="auto"
        data={dataGraphs}
        autoFit
        filter={[
          ['total', (val) => val != null], //renderiza o gráfico
        ]}
      >
        <Interval
          adjust={[
            {
              type: 'dodge',
              marginRatio: 0,
            },
          ]}
          // color="name"
          color={['name', ['#48daff', '#b3f0ff']]}
          position={position}
        />
        <Tooltip
          shared
          title={(value, idx) =>
            `${title ? title : 'Atendimentos'}: ${label} ${
              // prettier-ignore
              date?.find(
              (i) => (i.dia === idx.dia) && (i.total === idx.total) && (i.name === idx.name)
            ).dataFinal
            }`
          }
        />
        <Interaction type="active-region" />
        <Axis name="total" visible={false} />
        <Legend name="name" visible={false} />
      </Chart>
      <div className={styles.porcem_user_unico}>
        <p className={styles.graph_bar_total_label}>
          {title
            ? `${numberLocale(porcemPf)}${porcemSimbol ? porcemSimbol : ''} `
            : `${porcemPf}${porcemSimbol ? porcemSimbol : ''} `}
          {iten1 === 'enviados' ||
          iten1 === 'usuários' ||
          title === 'Acessos' ? (
            <>
              <br />
              <span style={{ color: '#B3F0FF', fontSize: '0.84rem' }}>
                {iten1}
              </span>
            </>
          ) : (
            <span style={{ color: '#B3F0FF' }}>{iten1}</span>
          )}
        </p>
        <p className={styles.graph_bar_total_label}>
          {title
            ? `${numberLocale(porcemPj)}${porcemSimbol ? porcemSimbol : ''} `
            : `${porcemPj}${porcemSimbol ? porcemSimbol : ''} `}
          {/* {`${porcemPj}${porcemSimbol ? porcemSimbol : ''} `} */}
          {iten2 === 'não enviados' ||
          iten2 === 'não usuários' ||
          title === 'Acessos' ? (
            <>
              <br />
              <span style={{ color: '#66E0FF', fontSize: '0.8rem' }}>
                {iten2}
              </span>
            </>
          ) : (
            <span style={{ color: '#66E0FF' }}>{iten2}</span>
          )}
        </p>
      </div>
    </div>
  );
};

export const GraphBarGroupedSimple = ({
  dataGraphs,
  position,
  title,
  label,
  iten1,
  iten2,
  itemTotal1,
  itemTotal2,
}) => {
  return (
    <div className={styles.graph_bar_content}>
      {/* <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>{title} :</p>

      <h3 className={styles.graph_bar_title}>{label}</h3> */}
      <div className={styles.graph_exp_title}>
        <div>
          <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>
            {title ? title : 'Atendimentos'}:
          </p>
          <h4 className={styles.graph_bar_title}>{label}</h4>
        </div>
        <div className={styles.graph_chartTooltip}>
          <ChartTooltip
            title={
              <React.Fragment>
                <Typography color="inherit">Legenda</Typography>
                <p>
                  {' '}
                  <strong>OTD: </strong> Orientação Técnica à Distância{' '}
                </p>
                <p>
                  {' '}
                  <strong>IAD: </strong> Informação à Distância{' '}
                </p>
                <p>
                  {' '}
                  <strong>CON: </strong> Consultoria{' '}
                </p>
              </React.Fragment>
            }
          >
            <svg
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.42268 8.22878C6.09729 7.92358 5.56981 7.92358 5.24404 8.22878C4.91865 8.53398 4.91865 9.0291 5.24404 9.3343L9.41077 13.2425C9.73616 13.5477 10.264 13.5477 10.5894 13.2425L14.7561 9.3343C15.0815 9.0291 15.0815 8.53434 14.7561 8.22878C14.4308 7.92358 13.9029 7.92358 13.5775 8.22878L10.0001 11.5842L6.42268 8.22878Z"
                fill="#00CCFF"
              />
              <path
                d="M10 0C4.48566 0 0 4.49954 0 10.0309C0 15.5623 4.48566 20.0619 10 20.0619C15.5143 20.0619 20 15.5615 20 10.0309C20 4.50032 15.5143 0 10 0ZM10 18.5079C5.34082 18.5079 1.54918 14.7053 1.54918 10.0309C1.54918 5.35656 5.34082 1.55397 10 1.55397C14.6592 1.55397 18.4508 5.35656 18.4508 10.0309C18.4508 14.7053 14.66 18.5079 10 18.5079Z"
                fill="#00CCFF"
              />
            </svg>
          </ChartTooltip>
        </div>
      </div>
      <Chart
        className={styles.data_graph_container}
        padding="auto"
        data={dataGraphs}
        autoFit
        filter={[
          ['total', (val) => val != null], //renderiza o gráfico
        ]}
      >
        <Coordinate actions={[['scale', 1, -1], ['transpose']]} />
        {/* <Axis
        name="label"
        label={{
          offset: 12,
        }}
      /> */}
        <Interaction type="active-region" />
        <Axis name="total" visible={false} />
        <Legend name="name" visible={false} />
        <Tooltip shared title={(value) => `Atendimentos: ${value}`} />
        <Interval
          position={position}
          color={['name', ['#48daff', '#b3f0ff']]}
          adjust={[
            {
              type: 'dodge',
              marginRatio: 1 / 32,
            },
          ]}
        />
      </Chart>
      <div className={styles.porcem_user_unico}>
        <p className={styles.graph_bar_total_label}>
          <span>{numberLocale(itemTotal1)}</span>
          <br />
          <span style={{ color: '#66E0FF', fontSize: '0.84rem' }}>{iten1}</span>
        </p>
        <p className={styles.graph_bar_total_label}>
          <span>{numberLocale(itemTotal2)}</span>
          <br />
          <span style={{ color: '#B3F0FF', fontSize: '0.84rem' }}>{iten2}</span>
        </p>
      </div>
    </div>
  );
};

// Gráfico Pizza
export const PizzaChart = ({
  item1Pf,
  item2Pj,
  label,
  title,
  subLabel1,
  subLabel2,
  porcemPf,
  porcemPj,
  tipoAtendimento,
  total1,
  total2,
}) => {
  const data = [
    { item: `${item1Pf}`, percent: porcemPf, total: total1 },
    { item: `${item2Pj}`, percent: porcemPj, total: total2 },
  ];
  // const colors = data.reduce((pre, cur, idx) => {
  //   pre[cur.item] = getTheme().colors10[idx];
  //   return pre;
  // }, {});

  const cols = {
    percent: {
      formatter: (val) => {
        // val = val * 100 + '%';
        val = val + '%';
        return val;
      },
    },
  };

  return (
    <div className={styles.graph_bar_content}>
      <div>
        <p style={{ fontSize: 12, marginLeft: '0.5rem' }}>
          {title ? title : 'Atendimentos'}{' '}
          {tipoAtendimento ? tipoAtendimento : ''}:
        </p>
        <h4 className={styles.graph_bar_title}>{label}</h4>
      </div>
      <Chart
        height={126}
        width={150}
        data={data}
        scale={cols}
        interactions={['element-active']}
        autoFit
        className={styles.data_graph_container}
      >
        <Coordinate
          type="theta"
          radius={0.75}
          rotate={label === 'perfil usuário único' ? '' : -Math.PI * 0.5}
        />
        <Tooltip
          showTitle={true}
          title={() =>
            `${title ? title : 'Atendimentos'} ${
              tipoAtendimento ? tipoAtendimento : ':'
            } \n ${label}`
          }
        />
        <Axis visible={false} />
        <Legend visible={false} />
        <Interval
          position="percent"
          adjust="stack"
          // color="item"
          color={['item', ['#b3f0ff', '#48daff']]}
          style={{
            lineWidth: 1,
            stroke: '#fff',
          }}
          label={[
            'item',
            (item) => {
              return {
                offset: 15,
                content: (data) => {
                  // return `${data.item}\n ${data.percent}%`;
                  return `${
                    label === 'perfil usuário único' ||
                    label === '% envio OK' ||
                    'perfil do usuário'
                      ? ''
                      : ` ${data.total}`
                  }`;
                },
                // style: {
                //   fill: colors[item],
                // },
              };
            },
          ]}
        />
      </Chart>
      <div className={styles.porcem_user_unico_pizza}>
        <p
          className={
            subLabel1
              ? styles.graph_bar_total_label_pizzaChart2
              : styles.graph_bar_total_label_pizzaChart
          }
        >
          {`${porcemPf}%  `}{' '}
          <span
            className="pf"
            style={
              subLabel1
                ? {
                    color: '#B3F0FF',
                    fontSize: '0.84rem',
                  }
                : label === '% envio OK'
                ? { color: '#B3F0FF', fontSize: '0.82rem' }
                : { color: '#B3F0FF' }
            }
          >
            {label === '% envio SAS' || label === '% usuários APP'
              ? subLabel1
              : label === '% envio OK'
              ? item1Pf
              : 'PF'}
          </span>{' '}
        </p>
        <p
          className={
            subLabel2
              ? styles.graph_bar_total_label_pizzaChart2
              : styles.graph_bar_total_label_pizzaChart
          }
        >
          {`${porcemPj}%  `}
          <span
            className="pj"
            style={
              subLabel2
                ? {
                    color: '#66E0FF',
                    fontSize: '0.84rem',
                  }
                : label === '% envio OK'
                ? { color: '#66E0FF', fontSize: '0.82rem' }
                : { color: '#66E0FF' }
            }
          >
            {label === '% envio SAS' || label === '% usuários APP'
              ? subLabel2
              : label === '% envio OK'
              ? item2Pj
              : 'PJ'}
          </span>
        </p>
      </div>
    </div>
  );
};
